/* Blank apparel size card (nbg2, Justin 2026-10-22) — cart page AND slide-out cart.
   Each .nt-blank-group.nbg2 (snippets/cart-form-page.liquid + cart-form.liquid) carries a data-nbg2 JSON blob
   with its lines; this draws one card per product + color: size pills with the tier price each, and Edit Sizes
   opens a SIZE / PRICE / QTY / TOTAL table for every size of the color, with steppers.
   The helpers below (tier pricing, size list, promo-safe qty split) are the same as the cart page's
   Add/Edit Size modal in sections/main-cart.liquid — that copy only loads on /cart, this one runs everywhere
   the drawer does. Keep the two in step. Styles: assets/nt-blank-card.css.

   Ninja Patches port (2026-10-23, ninjatransfers.com main 0b990635). Our blanks arrive through Shopify Collective, which
   copies no metafields, so there is no tier_pricing ladder: every price is the variant's own, as the cart charges it, and
   the struck price is the variant's compare-at (what NP's cart lines show), not the ×1.96 retail. Sizes come from
   /products/<handle>.js (NT's Storefront call used its own store + token). After Update Sizes / ✕ the cart PAGE reloads —
   NP's refreshCart() only re-renders the slide-out cart — and "+ Add a Color" opens NP's blanks quick-buy modal
   (assets/np-blanks-quickbuy.js), which NP already uses for colours + sizes; on /cart it reloads after an add (C312). */
(function () {
  'use strict';
  if (window.__ntBlankCard) return;
  window.__ntBlankCard = true;

  function money(c) { return '$' + (c / 100).toFixed(2); }
  var RETAIL_PRICE_MULTIPLIER = 1.96;
  function parseTierPricing(raw) {
    if (!raw) return [];
    var s = String(raw).trim(); if (!s) return [];
    try { var p = JSON.parse(s); if (Array.isArray(p)) s = p.join(','); } catch (e) {}
    return s.split(',').map(function (v) { return parseInt(v.trim(), 10); }).filter(function (n) { return n > 0; });
  }
  function getTierLevel(dollars) {
    if (dollars >= 3800) return 7; if (dollars >= 1750) return 6; if (dollars >= 1000) return 5;
    if (dollars >= 500) return 4; if (dollars >= 250) return 3; if (dollars >= 150) return 2;
    if (dollars >= 99) return 1; return 0;
  }
  function getTierPrice(base, raw, level) {
    var t = parseTierPricing(raw);
    if (level > 0 && t.length >= level) return t[level - 1];
    return base;
  }

  /* cart total + every line per variant (shares the 2s __ntCartCache with blanks-price-patcher) */
  var _popupCartTotal = 0;
  var _cartLinesByVariant = {};
  function refreshCartPriceMap(cb) {
    var cached = window.__ntCartCache;
    var p = (cached && cached.data && (Date.now() - cached.ts) < 2000)
      ? Promise.resolve(cached.data)
      : fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
          if (cart) window.__ntCartCache = { data: cart, ts: Date.now() };
          return cart;
        });
    p.then(function (cart) {
      _popupCartTotal = cart.total_price || 0;
      _cartLinesByVariant = {};
      cart.items.forEach(function (item) {
        var vid = String(item.variant_id);
        var hasDisc = (item.line_level_discount_allocations || []).length > 0;
        (_cartLinesByVariant[vid] = _cartLinesByVariant[vid] || []).push({ key: item.key, qty: item.quantity, tagged: hasDisc });
      });
      if (cb) cb();
    }).catch(function () { if (cb) cb(); });
  }
  /* new total qty for a variant across its lines, keeping promo-tagged lines intact (main-cart.liquid) */
  function distributeVariantQty(variantId, newQty, updateMap) {
    var lines = _cartLinesByVariant[String(variantId)] || [];
    var tagged = lines.filter(function (l) { return l.tagged; });
    var untagged = lines.filter(function (l) { return !l.tagged; });
    var taggedTotal = tagged.reduce(function (s, l) { return s + l.qty; }, 0);
    if (newQty >= taggedTotal) {
      tagged.forEach(function (l) { updateMap[l.key] = l.qty; });
      var remainder = newQty - taggedTotal;
      if (untagged.length > 0) {
        updateMap[untagged[0].key] = remainder;
        for (var i = 1; i < untagged.length; i++) updateMap[untagged[i].key] = 0;
      } else if (remainder > 0 && tagged.length) {
        updateMap[tagged[0].key] = tagged[0].qty + remainder;
      }
    } else {
      untagged.forEach(function (l) { updateMap[l.key] = 0; });
      var rem = newQty;
      for (var j = 0; j < tagged.length; j++) {
        if (rem >= tagged[j].qty) { updateMap[tagged[j].key] = tagged[j].qty; rem -= tagged[j].qty; }
        else { updateMap[tagged[j].key] = rem; rem = 0; }
      }
    }
  }
  /* every size of one color, from the product's own JSON (NP: no tier data to fetch) */
  var _pjCache = {};
  function variantsFromProductJs(handle, color, cb) {
    var want = String(color || '').trim().toLowerCase();
    if (!_pjCache[handle]) {
      _pjCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    }
    _pjCache[handle].then(function (p) {
      if (!p || !p.variants) { cb([]); return; }
      var names = (p.options || []).map(function (o) { return String(o && o.name || o || '').toLowerCase(); });
      var ci = names.indexOf('color'); if (ci < 0) ci = names.indexOf('colour'); if (ci < 0) ci = 0;
      var si = names.indexOf('size');
      cb(p.variants.filter(function (v) {
        return String((v.options || [])[ci] || '').trim().toLowerCase() === want;
      }).map(function (v) {
        return { id: String(v.id), size: si > -1 ? (v.options || [])[si] : v.title, color: (v.options || [])[ci], price: v.price,
                 compare: v.compare_at_price || 0, available: v.available, tierPricing: null };
      }));
    });
  }

  /* ── Blank apparel size card (nbg2, Justin 2026-10-22) ──
     Draws one card per blank product + color from the group's data-nbg2 JSON (snippets/cart-form-page.liquid):
     size pills with the tier price each, Edit Sizes → SIZE / PRICE / QTY / TOTAL table for EVERY size of the
     color (variantsFromProductJs on NP; NT reads its Storefront API). Steppers re-price live with the
     virtual cart total (same maths as refreshPopupTierPrices), then commit after a short pause through
     distributeVariantQty (promo-split lines stay intact) / cart add, and refresh the cart silently. */
  var _nbgOpen = {};      /* group key → table open */
  var _nbgFocus = {};     /* group key → bring the table into view once it draws */
  var _nbgEdits = {};     /* group key → { variantId: qty } not yet saved */
  var _nbgBusy = {};
  var _nbgCartTotal = null;

  function nbgData(g) {
    var el = g.querySelector('script[data-nbg2]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function nbgEsc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  /* the cart's lines for this card, merged per variant (a promo can split one variant into several lines) */
  function nbgVariants(d) {
    var map = {}, order = [];
    (d.lines || []).forEach(function (l) {
      var k = String(l.v);
      if (!map[k]) { map[k] = { v: k, s: l.s, b: l.b, c: l.c || 0, tp: l.tp, q: 0, free: 0 }; order.push(k); }
      map[k].q += l.q;
      if (l.f <= 0) map[k].free += l.q;
    });
    var sizes = (d.sizes || []).map(function (x) { return String(x); });
    order.sort(function (a, b) {
      var ia = sizes.indexOf(map[a].s), ib = sizes.indexOf(map[b].s);
      return (ia < 0 ? 999 : ia) - (ib < 0 ? 999 : ib);
    });
    return order.map(function (k) { return map[k]; });
  }
  function nbgUnit(b, tp, level) { return tp ? getTierPrice(b, tp, level) : b; }
  /* cart total with this card's unsaved edits applied, so the tier level moves as you type */
  function nbgLevel(key, rows) {
    var total = _nbgCartTotal == null ? (_popupCartTotal || 0) : _nbgCartTotal;
    var edits = _nbgEdits[key] || {};
    Object.keys(edits).forEach(function (vid) {
      var r = rows[vid];
      if (r) total += r.b * (edits[vid] - r.q);
    });
    return getTierLevel(total / 100);
  }

  function nbgRender(g) {
    var d = nbgData(g);
    if (!d) return;
    var key = g.getAttribute('data-group-key') || '';
    var vars = nbgVariants(d);
    var rows = {};
    vars.forEach(function (r) { rows[r.v] = r; });
    var edits = _nbgEdits[key] || {};
    var level = nbgLevel(key, rows);
    var qtyOf = function (r) { return edits[r.v] != null ? edits[r.v] : r.q; };

    var items = 0, total = 0, retail = 0, pills = '';
    vars.forEach(function (r) {
      var q = qtyOf(r);
      items += q;
      if (q <= 0) return;
      var unit = nbgUnit(r.b, r.tp, level);
      var paid = Math.max(0, q - Math.min(r.free, q));
      total += unit * paid;
      retail += (r.tp ? Math.round(unit * RETAIL_PRICE_MULTIPLIER) : (r.c > r.b ? r.c : r.b)) * q;
      pills += '<span class="nbg2-pill"><span class="nbg2-pill__tag"><b>' + nbgEsc(r.s || '—') + '</b> &times; ' + q + '</span><span class="nbg2-pill__ea"><span class="nbg2-ea">' + money(unit) + '</span> ea</span></span>';
    });
    /* sizes added in the table that aren't cart lines yet */
    Object.keys(edits).forEach(function (vid) {
      if (rows[vid] || !(edits[vid] > 0)) return;
      var sv = (_nbgSizeCache[key] || []).filter(function (x) { return String(x.id) === vid; })[0];
      if (!sv) return;
      var unit = nbgUnit(sv.price, sv.tierPricing, level);
      items += edits[vid];
      total += unit * edits[vid];
      retail += (sv.tierPricing ? Math.round(unit * RETAIL_PRICE_MULTIPLIER) : (sv.compare > sv.price ? sv.compare : sv.price)) * edits[vid];
      pills += '<span class="nbg2-pill"><span class="nbg2-pill__tag"><b>' + nbgEsc(sv.size) + '</b> &times; ' + edits[vid] + '</span><span class="nbg2-pill__ea"><span class="nbg2-ea">' + money(unit) + '</span> ea</span></span>';
    });

    var open = !!_nbgOpen[key];
    /* Update Sizes stays grey until a size differs from what's in the cart */
    var dirty = Object.keys(edits).some(function (vid) { return edits[vid] !== (rows[vid] ? rows[vid].q : 0); });
    var card = g.querySelector(':scope > .nbg2-card');
    if (!card) {
      card = document.createElement('div');
      card.className = 'nbg2-card';
      g.insertBefore(card, g.firstChild);
    }
    card.classList.toggle('is-open', open);
    card.innerHTML =
      '<div class="nbg2-head">' +
        '<div class="nbg2-thumb">' + (d.thumb ? '<img src="' + nbgEsc(d.thumb) + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div class="nbg2-info">' +
          '<a class="nbg2-title" href="' + nbgEsc(d.url) + '">' + nbgEsc(d.title) + '</a>' +
          '<div class="nbg2-meta">Color: <strong>' + nbgEsc(String(d.color || '').toLowerCase()) + '</strong> &middot; ' + items + (items === 1 ? ' item' : ' items') + '</div>' +
          '<div class="nbg2-pills">' + pills + '<button type="button" class="nbg2-edit" data-nbg2-toggle>Edit Sizes<span class="nbg2-caret">&#9660;</span></button></div>' +
        '</div>' +
        '<div class="nbg2-price">' + (retail > total ? '<del>' + money(retail) + '</del>' : '') + '<strong>' + money(total) + '</strong>' +
        /* remove this color: the design cards' master X (handler in assets/nt-cart-actions.js) */
        '<button type="button" class="nt-dg-remove-all nbg2-x" data-nt-remove-keys="' + nbgEsc((d.lines || []).map(function (l) { return l.k; }).join(',')) + '" title="Remove this color" aria-label="Remove ' + nbgEsc(d.title + ' ' + String(d.color || '').toLowerCase()) + '"></button></div>' +
      '</div>' +
      (open
        ? '<button type="button" class="nbg2-bar nbg2-bar--top" data-nbg2-toggle>Hide size breakdown<span class="nbg2-caret">&#9650;</span></button>' +
          '<div class="nbg2-table" data-nbg2-table><div class="nbg2-loading">Loading sizes…</div></div>' +
          '<div class="nbg2-confirm-wrap"><button type="button" class="nbg2-confirm" data-nbg2-confirm' + (_nbgBusy[key] || !dirty ? ' disabled' : '') + '>' + (_nbgBusy[key] ? 'Saving…' : 'Update Sizes') + '</button></div>'
        : '');
    g.classList.add('nbg2-on');
    card.classList.toggle('is-saving', !!_nbgBusy[key]);
    if (open) nbgTable(g, d, key, rows, level);
    nbgEditState();
  }
  /* while a size table is open, Checkout hides in the slide-out cart and on phone cart pages (CSS) */
  function nbgEditState() {
    var b = document.body;
    if (!b) return;
    b.classList.toggle('nbg2-edit-drawer', !!document.querySelector('#site-cart-sidebar .nbg2-card.is-open'));
    b.classList.toggle('nbg2-edit-page', !!document.querySelector('.nbg2-card.is-open:not(#site-cart-sidebar .nbg2-card)'));
  }

  var _nbgSizeCache = {};
  function nbgTable(g, d, key, rows, level) {
    function draw(list) {
      var box = g.querySelector('[data-nbg2-table]');
      if (!box) return;
      if (!list.length) { box.innerHTML = '<div class="nbg2-loading">Sizes could not be loaded. <a href="' + nbgEsc(d.url) + '">Open the product</a></div>'; return; }
      var edits = _nbgEdits[key] || {};
      var html = '<div class="nbg2-row nbg2-row--head"><span>Size</span><span>Price</span><span>Qty</span><span>Total</span></div>';
      list.forEach(function (v) {
        var vid = String(v.id), r = rows[vid];
        var q = edits[vid] != null ? edits[vid] : (r ? r.q : 0);
        var soldOut = !v.available && !r;
        var unit = nbgUnit(v.price, v.tierPricing, level);
        html += '<div class="nbg2-row' + (soldOut ? ' is-soldout' : '') + '" data-nbg2-vid="' + vid + '">' +
          '<span class="nbg2-size">' + nbgEsc(v.size) + '</span>' +
          '<span class="nbg2-unit"><span class="nbg2-ea">' + money(unit) + '</span> ea</span>' +
          '<span class="nbg2-step">' +
            '<button type="button" data-nbg2-step="-1" aria-label="Decrease ' + nbgEsc(v.size) + '"' + (soldOut || q <= 0 ? ' disabled' : '') + '>&minus;</button>' +
            /* a text box with the number keypad, not type=number: a number field won't hold a select-all, so a click then a
               digit typed in front of the old value (2 -> 52) instead of replacing it (Justin 2026-10-23) */
            '<input type="text" inputmode="numeric" pattern="[0-9]*" autocomplete="off" value="' + q + '" aria-label="' + nbgEsc(v.size) + ' quantity" data-nbg2-qty' + (soldOut ? ' disabled' : '') + '>' +
            '<button type="button" data-nbg2-step="1" aria-label="Increase ' + nbgEsc(v.size) + '"' + (soldOut ? ' disabled' : '') + '>+</button>' +
          '</span>' +
          '<span class="nbg2-line">' + (soldOut ? 'Sold out' : (q > 0 ? money(unit * q) : '&mdash;')) + '</span>' +
        '</div>';
      });
      box.innerHTML = html;
      /* just opened: bring this card's size table into view (scroll-margin in the CSS clears the sticky header) */
      if (_nbgFocus[key]) {
        delete _nbgFocus[key];
        var card = g.querySelector('.nbg2-card');
        if (card) card.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    }
    if (_nbgSizeCache[key]) { draw(_nbgSizeCache[key]); return; }
    variantsFromProductJs(d.handle, d.color, function (list) { _nbgSizeCache[key] = list; nbgRender(g); });
  }

  function nbgRenderAll() {
    document.querySelectorAll('.nt-blank-group.nbg2').forEach(nbgRender);
  }
  function nbgRefreshTotals() {
    refreshCartPriceMap(function () { _nbgCartTotal = _popupCartTotal; nbgRenderAll(); });
  }

  function nbgSet(g, vid, q) {
    var key = g.getAttribute('data-group-key') || '';
    q = Math.max(0, parseInt(q, 10) || 0);
    (_nbgEdits[key] = _nbgEdits[key] || {})[vid] = q;
    nbgRender(g);
  }
  /* Confirm: save this card's edits, close its table, refresh the cart */
  function nbgSave(g, key) {
    if (_nbgBusy[key]) return;
    var edits = _nbgEdits[key];
    if (!edits || !Object.keys(edits).length) { _nbgOpen[key] = false; nbgRender(g); return; }
    _nbgBusy[key] = true;
    nbgRender(g);
    /* fresh line map first — distributeVariantQty needs the current split of each variant's lines */
    refreshCartPriceMap(function () {
      var sent = {};
      var updates = {}, adds = [];
      Object.keys(edits).forEach(function (vid) {
        sent[vid] = edits[vid];
        if (_cartLinesByVariant[vid]) distributeVariantQty(vid, edits[vid], updates);
        else if (edits[vid] > 0) adds.push({ id: Number(vid), quantity: edits[vid] });
      });
      var post = function (url, body) {
        return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
          .then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
      };
      var chain = Promise.resolve();
      if (Object.keys(updates).length) chain = chain.then(function () { return post('/cart/update.js', { updates: updates }); });
      if (adds.length) chain = chain.then(function () { return post('/cart/add.js', { items: adds }); });
      chain.then(function () {
        /* drop what was saved; anything typed meanwhile stays queued */
        var cur = _nbgEdits[key] || {};
        Object.keys(sent).forEach(function (vid) { if (cur[vid] === sent[vid]) delete cur[vid]; });
        _nbgBusy[key] = false;
        _nbgOpen[key] = false;
        window.__ntCartCache = null;
        nbgCartChanged(g);
      }).catch(function () {
        _nbgBusy[key] = false;
        nbgRender(g);
        nbgCartChanged(g);
        if (window.toast) window.toast('Cart', 'Sorry, that size could not be updated. Please try again.', 'red');
      });
    });
  }

  /* NP: the cart page renders its lines server-side (refreshCart() only swaps the slide-out cart's form), so a change made
     on /cart reloads it; in the slide-out cart the form re-renders quietly */
  function nbgCartChanged(g) {
    var inDrawer = g && g.closest && g.closest('#site-cart-sidebar');
    if (!inDrawer && /^\/(?:[a-z]{2}(?:-[a-zA-Z]{2})?\/)?cart\/?$/.test(location.pathname)) { location.reload(); return; }
    if (typeof window.refreshCart === 'function') window.refreshCart('notOpen'); else location.reload();
  }

  /* "+ Add a Color" = NP's blanks quick-buy modal for this product (assets/np-blanks-quickbuy.js): it boots only when a
     [data-bqb-handle] is on the page (the group carries one, data-bqb="1" so it adds no bar of its own) and opens from a
     [data-bqb-open] click; its colour chips need np-blanks-swatch-colors.js. Loaded on first use when the page has neither. */
  var _assetBase = (function () {
    var cs = document.currentScript && document.currentScript.src;
    return cs ? cs.replace(/nt-blank-card\.js.*$/, '') : '';
  })();
  function loadOnce(name, test) {
    if (test()) return Promise.resolve();
    return new Promise(function (res) {
      var s = document.createElement('script');
      s.src = _assetBase + name; s.onload = s.onerror = function () { res(); };
      document.head.appendChild(s);
    });
  }
  function nbgAddColor(g) {
    var handle = g.getAttribute('data-product-handle');
    if (!handle) return;
    loadOnce('np-blanks-swatch-colors.js', function () { return !!window.NP_BLANK_COLORS; })
      .then(function () { return loadOnce('np-blanks-quickbuy.js', function () { return !!window.__npBlanksQuickBuy; }); })
      .then(function () {
        if (!window.__npBlanksQuickBuy) { location.href = g.getAttribute('data-product-url') || ('/products/' + handle); return; }
        var b = document.createElement('button');
        b.type = 'button'; b.hidden = true; b.setAttribute('data-bqb-open', handle);
        g.appendChild(b); b.click(); b.remove();
      });
  }

  document.addEventListener('click', function (e) {
    var ac = e.target.closest && e.target.closest('[data-nbg2-addcolor]');
    if (ac) { e.preventDefault(); nbgAddColor(ac.closest('.nt-blank-group.nbg2')); return; }
    var t = e.target.closest('[data-nbg2-toggle]');
    if (t) {
      var g = t.closest('.nt-blank-group.nbg2');
      var key = g.getAttribute('data-group-key') || '';
      _nbgOpen[key] = !_nbgOpen[key];
      if (_nbgOpen[key]) _nbgFocus[key] = true;
      else delete _nbgEdits[key];   /* closed without Confirm: drop the changes */
      nbgRender(g);
      if (!_nbgOpen[key] && g.getBoundingClientRect().top < 0) g.scrollIntoView({ block: 'start', behavior: 'smooth' });
      return;
    }
    var cf = e.target.closest('[data-nbg2-confirm]');
    if (cf) { var gc = cf.closest('.nt-blank-group.nbg2'); nbgSave(gc, gc.getAttribute('data-group-key') || ''); return; }
    var st = e.target.closest('[data-nbg2-step]');
    if (st) {
      var row = st.closest('[data-nbg2-vid]');
      var inp = row.querySelector('[data-nbg2-qty]');
      nbgSet(st.closest('.nt-blank-group.nbg2'), row.getAttribute('data-nbg2-vid'), (parseInt(inp.value, 10) || 0) + Number(st.getAttribute('data-nbg2-step')));
    }
  });
  /* clicking into a size's quantity selects the number EVERY time, so typing replaces it (Justin 2026-10-23): on focus
     (click, tap or Tab) and on every later click into a box that already has focus — a click there drops the selection to a
     caret, so it is put back; a drag that selects part of the number is left alone */
  function nbgSelAll(inp) { try { inp.setSelectionRange(0, String(inp.value || '').length); } catch (x) { try { inp.select(); } catch (y) {} } }
  document.addEventListener('focusin', function (e) {
    var inp = e.target;
    if (!inp || !inp.matches || !inp.matches('[data-nbg2-qty]')) return;
    inp.__nbgSelUp = true;
    setTimeout(function () { nbgSelAll(inp); }, 0);
  });
  document.addEventListener('mouseup', function (e) {
    var inp = e.target;
    if (!inp || !inp.matches || !inp.matches('[data-nbg2-qty]')) return;
    if (inp.__nbgSelUp) { inp.__nbgSelUp = false; e.preventDefault(); nbgSelAll(inp); return; }   /* Safari drops the focus selection on this mouseup */
    if (inp.selectionStart === inp.selectionEnd) { e.preventDefault(); nbgSelAll(inp); }
  });
  /* …and once more on click, for a browser that puts the caret back after the mouseup */
  document.addEventListener('click', function (e) {
    var inp = e.target;
    if (inp && inp.matches && inp.matches('[data-nbg2-qty]') && inp.selectionStart === inp.selectionEnd) nbgSelAll(inp);
  });
  /* digits only (the box is a text field so it can hold the select-all) */
  document.addEventListener('input', function (e) {
    var inp = e.target;
    if (!inp || !inp.matches || !inp.matches('[data-nbg2-qty]')) return;
    var clean = String(inp.value || '').replace(/\D/g, '').slice(0, 4);
    if (clean !== inp.value) inp.value = clean;
  });
  document.addEventListener('change', function (e) {
    var inp = e.target.closest('[data-nbg2-qty]');
    if (inp) nbgSet(inp.closest('.nt-blank-group.nbg2'), inp.closest('[data-nbg2-vid]').getAttribute('data-nbg2-vid'), inp.value);
  });
  /* cart forms re-render their HTML after every change (component-cart.js refreshCart / qty updates) and the
     drawer's form can arrive later: draw any group that has no card yet, then re-price once /cart.js is back */
  var _nbgQueued = false;
  function nbgScan() {
    _nbgQueued = false;
    document.documentElement.classList.remove('nbg2-pending');   /* the cards draw in this same task, so nothing paints in between; a group that fails to draw shows its plain lines */
    nbgEditState();   /* a removed card must not leave Checkout hidden */
    if (!document.querySelector('.nt-blank-group.nbg2:not(.nbg2-on)')) return;
    document.querySelectorAll('.nt-blank-group.nbg2:not(.nbg2-on)').forEach(nbgRender);
    nbgRefreshTotals();
  }
  new MutationObserver(function () {
    if (_nbgQueued) return;
    _nbgQueued = true;
    requestAnimationFrame(nbgScan);
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', nbgScan); else nbgScan();
})();
